(function () {
  if (window._ddFeaturedGrid) return;
  window._ddFeaturedGrid = true;

  var storyEl = document.querySelector('[data-scroll-story]');
  if (!storyEl) return;

  /* mqMobile is a live MediaQueryList (not a one-shot bool) so the code
     can react to viewport changes — desktop<->mobile rotation rebinds the
     IntersectionObserver to the correct root (cards track on mobile, the
     viewport on desktop) and retargets / restores the CTA. */
  var mqMobile       = window.matchMedia('(max-width: 768px)');
  var hasHover       = window.matchMedia('(hover: hover)').matches;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Background luminance — pre-computed per image, applied on switch
     Probes the bottom 30% of every image in each card once at load time
     (all imgs have crossorigin="anonymous" so canvas is never tainted).
     switchBgToImg() is called whenever the active image changes so the
     panel text/button palette stays legible against any background.
     ------------------------------------------------------------------ */

  function probeImageLum(src, onResult) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var W = 32, H = 16;
      var canvas = document.createElement('canvas');
      canvas.width = W; canvas.height = H;
      var ctx = canvas.getContext('2d');
      try {
        var sy = Math.floor(probe.naturalHeight * 0.70);
        var sh = probe.naturalHeight - sy;
        ctx.drawImage(probe, 0, sy, probe.naturalWidth, sh, 0, 0, W, H);
        var d = ctx.getImageData(0, 0, W, H).data;
        var s = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) {
          s += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
          n++;
        }
        onResult(n > 0 ? s / n : null);
      } catch (e) { onResult(null); }
    };
    probe.onerror = function () { onResult(null); };
    probe.src = src;
  }

  function applyLum(card, lum) {
    if (lum === null) return;
    card.classList.toggle('dd-glass-card--light-bg', lum > 145);
  }

  function initCardLuminance(card) {
    var allImgs = Array.from(card.querySelectorAll('.dd-glass-card__img'));
    card._lumImgs = allImgs;
    card._lumVals = allImgs.map(function () { return null; });
    allImgs.forEach(function (img, i) {
      if (!img.src) return;
      probeImageLum(img.src, function (lum) {
        card._lumVals[i] = lum;
        /* Apply immediately for the cover (index 0) */
        if (i === 0) applyLum(card, lum);
      });
    });
  }

  function switchBgToImg(card, img) {
    if (!card._lumImgs) return;
    var i = card._lumImgs.indexOf(img);
    if (i === -1) return;
    applyLum(card, card._lumVals[i]);
  }

  storyEl.querySelectorAll('.dd-glass-card').forEach(function (card) {
    initCardLuminance(card);
  });

  /* ------------------------------------------------------------------
     Image carousel
     Image 0 = cover (always visible at rest, class .dd-glass-card__img--cover)
     Images 1-3 = carousel only ([data-carousel-index="0/1/2"])

     Desktop (hover): mouse sweep across card width maps to carousel images.
     Mobile  (touch): horizontal swipe advances / reverses.

     Panel thumbnail shows the cover image only — static, no JS needed.
     Progress dots track which carousel image is active (none active at rest).
     ------------------------------------------------------------------ */

  storyEl.querySelectorAll('.dd-glass-card[data-carousel-count]').forEach(function (card) {
    var count = parseInt(card.getAttribute('data-carousel-count'), 10);
    if (count < 1) return;

    /* Carousel images only — the cover has no data-carousel-index */
    var imgs = Array.from(card.querySelectorAll('.dd-glass-card__img[data-carousel-index]'));
    var dots = Array.from(card.querySelectorAll('.dd-glass-card__dot[data-dot-index]'));
    if (!imgs.length) return;

    var currentIdx = 0; /* desktop: current carousel position */
    var coverImg   = card.querySelector('.dd-glass-card__img--cover');

    /* Activate dot idx, deactivate dot prevIdx */
    function setDot(prevIdx, nextIdx) {
      if (!dots.length) return;
      dots[prevIdx] && dots[prevIdx].classList.remove('is--active');
      dots[nextIdx] && dots[nextIdx].classList.add('is--active');
    }

    /* ---- Desktop: mouse-position sweep ----------------------------- */
    if (hasHover && !prefersReduced) {
      card.addEventListener('mouseenter', function () {
        card.classList.add('is--carousel-active');
        /* Show first carousel image (product image 2) immediately on hover */
        imgs[0].classList.add('is--active');
        dots[0] && dots[0].classList.add('is--active');
        currentIdx = 0;
        switchBgToImg(card, imgs[0]);
      });

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x   = (e.clientX - rect.left) / rect.width;
        var idx = Math.min(count - 1, Math.max(0, Math.floor(x * count)));
        if (idx !== currentIdx) {
          imgs[currentIdx].classList.remove('is--active');
          setDot(currentIdx, idx);
          currentIdx = idx;
          imgs[currentIdx].classList.add('is--active');
          switchBgToImg(card, imgs[currentIdx]);
        }
      });

      card.addEventListener('mouseleave', function () {
        card.classList.remove('is--carousel-active');
        imgs[currentIdx].classList.remove('is--active');
        /* Clear active dot — no dot is active when cover is showing */
        dots[currentIdx] && dots[currentIdx].classList.remove('is--active');
        currentIdx = 0;
        /* Restore cover image's luminance when carousel exits */
        switchBgToImg(card, coverImg);
      });
    }

    /* ---- Mobile: horizontal swipe ---------------------------------- */
    if (!hasHover) {
      var touchStartX = 0;
      var touchStartY = 0;
      /*
        touchIdx = -1 means cover is showing (carousel not yet engaged).
        First swipe activates the carousel and starts from carousel image 0
        (swipe left) or carousel image count-1 (swipe right).
      */
      var touchIdx = -1;

      card.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });

      card.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;

        /* Ignore taps and vertical scrolls */
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        /* Confirmed horizontal swipe — cancel link navigation */
        e.preventDefault();

        var newIdx;

        if (touchIdx < 0) {
          /* First carousel engagement — show image 2 or last image */
          newIdx = dx < 0 ? 0 : count - 1;
          card.classList.add('is--carousel-active');
        } else {
          newIdx = dx < 0
            ? (touchIdx + 1) % count          /* swipe left  → next */
            : (touchIdx - 1 + count) % count; /* swipe right → prev */
          imgs[touchIdx].classList.remove('is--active');
          dots[touchIdx] && dots[touchIdx].classList.remove('is--active');
        }

        touchIdx = newIdx;
        imgs[touchIdx].classList.add('is--active');
        dots[touchIdx] && dots[touchIdx].classList.add('is--active');
        switchBgToImg(card, imgs[touchIdx]);
      }, { passive: false });
    }
  });

  /* ------------------------------------------------------------------
     Entrance animations
     One-shot IntersectionObserver per card and for the center column.
     Adds .is--entered which triggers CSS opacity/translate transitions.
     Runs on both mobile and desktop (placed before mobile early-return).
     ------------------------------------------------------------------ */

  if (!prefersReduced) {
    /* Cards — fire individually so each card reveals as it scrolls in */
    var cardEntranceObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is--entered');
        cardEntranceObs.unobserve(entry.target);
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -4% 0px' });

    storyEl.querySelectorAll('.dd-story__card').forEach(function (card) {
      cardEntranceObs.observe(card);
    });

    /* Center column (desktop) + mobile block — one-shot reveal each.
       CSS targets `.dd-story__center.is--entered > *` for desktop and
       `.dd-story-mobile.is--entered > * > *` for mobile, so firing on
       either root triggers the staged eyebrow → heading → body → CTA
       fade-in. Only whichever is visible at the current breakpoint
       will render; the other is display:none and IO won't fire. */
    [
      storyEl.querySelector('.dd-story__center'),
      storyEl.querySelector('.dd-story-mobile')
    ].forEach(function (el) {
      if (!el) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is--entered');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.10 });

      obs.observe(el);
    });
  }

  /* ==================================================================
     Slot-machine / story swap — two independent DOM trees
     --------------------------------------------------------------------
     Desktop and mobile each render their own `.dd-story__*` (desktop)
     or `.dd-story-mobile__*` (mobile) markup. Only the one matching the
     current breakpoint is display:block; the other is hidden via CSS.

     A "story controller" owns:
       • a clip + track (slot-machine heading)
       • an array of heading nodes (source of truth for totalSlides)
       • body nodes          (cross-fade)
       • progress segments   (desktop only — mobile has none)
       • a "cards" scrollport (observer root on mobile, null on desktop)
       • an array of observable `.dd-story__card` nodes

     Both controllers share the same measure / apply-translate / set-
     active-slide logic via `createStoryController()`. Whichever one is
     "live" at load time measures itself and binds its IntersectionObserver;
     on viewport rotation across 768px we tear down the old observer and
     bind the new controller.
     ================================================================== */

  function createStoryController(roots) {
    /* roots shape:
         { clip, track, bodies, segs, cards (scrollport), cardNodes,
           storyAttr: 'data-story-index' | 'data-mobile-story-index',
           observerRoot: HTMLElement|null,
           observerOpts: { threshold, rootMargin }
         } */
    var headings = roots.track
      ? Array.from(roots.track.children).filter(function (n) {
          return n.nodeType === 1; /* only element children, not text */
        })
      : [];

    var ctrl = {
      roots: roots,
      headings: headings,
      totalSlides: headings.length,
      activeIndex: 0,
      headingOffsets: [],
      observer: null,
      visibleMap: {}
    };

    function applyTrackTranslate(idx, animate) {
      if (!roots.track || !ctrl.headingOffsets.length) return;
      var offset = ctrl.headingOffsets[idx] || 0;
      if (!animate) {
        roots.track.style.transition = 'none';
        roots.track.style.transform  = 'translateY(-' + offset + 'px)';
        roots.track.offsetHeight; // eslint-disable-line no-unused-expressions
        roots.track.style.transition = '';
      } else {
        roots.track.style.transform = 'translateY(-' + offset + 'px)';
      }
    }

    ctrl.measure = function () {
      if (!roots.clip || !headings.length) return;

      /* Reset so previous measurements don't skew this pass. Headings
         must measure at their natural height, not the slotted height
         we're about to force on them. */
      roots.clip.style.height = '';
      headings.forEach(function (h) { h.style.minHeight = ''; h.style.height = ''; });

      var maxH = 0;
      headings.forEach(function (h) {
        var hh = h.getBoundingClientRect().height;
        if (hh === 0) hh = h.offsetHeight;
        if (hh > maxH) maxH = hh;
      });

      /* Slot each heading into an equal-height box (= tallest heading).
         Without this, shorter headings leave a gap at the bottom of the
         clip and the next heading's first line bleeds through. With it,
         offsets are exact multiples of one slot, so translateY lines the
         active heading up perfectly regardless of line-count variance. */
      headings.forEach(function (h) { h.style.minHeight = maxH + 'px'; });

      var offsets = [];
      for (var i = 0; i < headings.length; i++) offsets.push(i * maxH);

      ctrl.headingOffsets = offsets;
      roots.clip.style.height = maxH + 'px';

      applyTrackTranslate(ctrl.activeIndex, false);
    };

    ctrl.setActive = function (idx) {
      if (idx === ctrl.activeIndex && ctrl.headingOffsets.length) return;
      ctrl.activeIndex = idx;

      applyTrackTranslate(idx, true);

      roots.bodies.forEach(function (el) {
        /* Bodies on desktop use [data-slide-body]; on mobile they use
           [data-mobile-body-index]. Read whichever exists. */
        var raw =
          el.getAttribute('data-slide-body') ||
          el.getAttribute('data-mobile-body-index');
        var elIdx = parseInt(raw, 10);
        el.classList.toggle('is-active', elIdx === idx);
      });

      /* CTAs cross-fade in lockstep with bodies. Desktop attr:
         [data-slide-cta]; mobile: [data-mobile-cta-index]. If a slide
         has no CTA (empty cta_text on both block and section), no node
         exists for that index — we just leave the previous CTA hidden
         since none will match and get `is-active`. */
      if (roots.ctas) {
        roots.ctas.forEach(function (el) {
          var raw =
            el.getAttribute('data-slide-cta') ||
            el.getAttribute('data-mobile-cta-index');
          var elIdx = parseInt(raw, 10);
          el.classList.toggle('is-active', elIdx === idx);
        });
      }

      roots.segs.forEach(function (seg) {
        var sIdx = parseInt(seg.getAttribute('data-seg-index'), 10);
        seg.classList.toggle('is--past',   sIdx < idx);
        seg.classList.toggle('is--active', sIdx === idx);
      });
    };

    ctrl.bindObserver = function () {
      if (ctrl.observer) { ctrl.observer.disconnect(); ctrl.observer = null; }
      ctrl.visibleMap = {};

      if (!roots.cardNodes.length) return;

      ctrl.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var key = entry.target.getAttribute(roots.storyAttr);
          if (entry.isIntersecting) {
            ctrl.visibleMap[key] = entry.intersectionRatio;
          } else {
            delete ctrl.visibleMap[key];
          }
        });

        var bestKey = null, bestRatio = 0;
        for (var k in ctrl.visibleMap) {
          if (ctrl.visibleMap[k] > bestRatio) {
            bestRatio = ctrl.visibleMap[k];
            bestKey = k;
          }
        }

        if (bestKey !== null) {
          var n = parseInt(bestKey, 10);
          if (!isNaN(n) && n >= 0 && n < ctrl.totalSlides) {
            ctrl.setActive(n);
          }
        }
      }, roots.observerOpts);

      roots.cardNodes.forEach(function (card) { ctrl.observer.observe(card); });
    };

    ctrl.disconnect = function () {
      if (ctrl.observer) { ctrl.observer.disconnect(); ctrl.observer = null; }
      ctrl.visibleMap = {};
    };

    return ctrl;
  }

  /* ---- Desktop roots ------------------------------------------------ */

  var desktopCardNodes = Array.from(
    storyEl.querySelectorAll('.dd-story__layout .dd-story__card[data-story-index]')
  );

  var desktopCtrl = createStoryController({
    clip:    storyEl.querySelector('[data-headline-clip]'),
    track:   storyEl.querySelector('[data-headline-track]'),
    bodies:  Array.from(storyEl.querySelectorAll('[data-slide-body]')),
    ctas:    Array.from(storyEl.querySelectorAll('.dd-story__cta-wrap [data-slide-cta]')),
    segs:    Array.from(storyEl.querySelectorAll('.dd-story__progress-seg[data-seg-index]')),
    cards:   storyEl.querySelector('[data-story-cards]'),
    cardNodes:    desktopCardNodes,
    storyAttr:    'data-story-index',
    observerRoot: null,
    observerOpts: {
      threshold: [0.10, 0.30, 0.55, 0.75],
      rootMargin: '0px 0px -15% 0px'
    }
  });

  /* ---- Mobile roots ------------------------------------------------- */

  var mobileRoot = storyEl.querySelector('[data-story-mobile]');
  var mobileCardsEl = mobileRoot ? mobileRoot.querySelector('[data-mobile-cards]') : null;
  var mobileStoryCardNodes = mobileRoot
    ? Array.from(mobileRoot.querySelectorAll('.dd-story-mobile__slide[data-mobile-story-index]'))
    : [];

  var mobileCtrl = mobileRoot ? createStoryController({
    clip:    mobileRoot.querySelector('[data-mobile-clip]'),
    track:   mobileRoot.querySelector('[data-mobile-track]'),
    bodies:  Array.from(mobileRoot.querySelectorAll('[data-mobile-body-index]')),
    ctas:    Array.from(mobileRoot.querySelectorAll('.dd-story-mobile__cta-wrap [data-mobile-cta-index]')),
    segs:    [],
    cards:   mobileCardsEl,
    cardNodes:    mobileStoryCardNodes,
    storyAttr:    'data-mobile-story-index',
    observerRoot: mobileCardsEl || null,
    observerOpts: {
      root: mobileCardsEl || null,
      threshold: [0.25, 0.5, 0.75, 1.0]
    }
  }) : null;

  /* ---- Activate whichever controller matches the current breakpoint - */

  function activateController() {
    if (mqMobile.matches) {
      /* Tear down desktop observer (desktop DOM is display:none now
         so the IO would report every card as 0-intersect anyway, but
         disconnecting is cleaner and saves the callback churn). */
      desktopCtrl.disconnect();

      if (mobileCtrl) {
        mobileCtrl.measure();
        mobileCtrl.bindObserver();
      }
    } else {
      if (mobileCtrl) mobileCtrl.disconnect();

      desktopCtrl.measure();
      desktopCtrl.bindObserver();
    }
  }

  /* Initial run — wait for fonts so heading heights are final. */
  function bootstrap() {
    activateController();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(bootstrap);
  } else {
    bootstrap();
  }

  /* Re-measure on resize (re-measures only the active controller —
     the inactive one is display:none and would read 0-height). */
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (mqMobile.matches) {
        if (mobileCtrl) mobileCtrl.measure();
      } else {
        desktopCtrl.measure();
      }
    }, 120);
  }, { passive: true });

  /* Breakpoint rotation — swap active controller. */
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', function () {
      activateController();
    });
  }

})();
